export default "__VITE_ASSET__BS9pVmtY__"